import React, { useState, useEffect } from "react";
import { reportsName } from "../Options";
import Sidebar from "../Sidebar";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
export default function CreateReport() {
  // const [selectedCommodity, setSelectedCommodity] = useState("");
  // const [reportTypes, setReportTypes] = useState(
  //   reportsName.map((item) => item.reportsType)
  // );

  const [selectedReportType, setSelectedReportType] = useState("");
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  const [statusMessage, setStatusMessage] = useState({ type: "", message: "" });

  // Add at the top with other state declarations
  const [formData, setFormData] = useState({
    // commodity: "",
    reportType: "",
    dateFrom: "",
    dateTo: "",
    publishDate: "",
    synopticSituationSummaryText: "",
    synopticSituationHeadingText: "",
    synopticSituationBulletText: "",
    mapText: "",
  });
  const [mapPhoto, setMapPhoto] = useState(null);

  useEffect(() => {
    if (statusMessage.message) {
      const timer = setTimeout(
        () => setStatusMessage({ type: "", message: "" }),
        5000
      );
      return () => clearTimeout(timer);
    }
  }, [statusMessage]);

  // const handleCommodityChange = (e) => {
  //   const selected = e.target.value;
  //   setSelectedCommodity(selected);
  //   setFormData((prev) => ({ ...prev, commodity: selected }));

  //   const found = commodities.find((item) => item.commodity === selected);
  //   // console.log(selected);
  //   setReportTypes(found ? found.reportsType : []);
  //   setSelectedReportType(""); // reset report type on commodity change
  // };

  const handleSummaryChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      synopticSituationSummaryText: e.target.value,
    }));
  };

  const handleHeadingChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      synopticSituationHeadingText: e.target.value,
    }));
  };

  const handleMapText = (e) => {
    setFormData((prev) => ({
      ...prev,
      mapText: e.target.value,
    }));
  };

  const handleMapPhotoUpload = (e) => {
    setMapPhoto(e.target.files[0]);
    // console.log(e.target.files[0]);
  };

  //handle to date -
  const handleStartDate = (e) => {
    // set date to date type

    setFormData((prev) => ({
      ...prev,
      dateFrom: e.target.value,
    }));
    setStartDate(e.target.value);
  };

  //handle from date
  const handleEndDate = (e) => {
    setFormData((prev) => ({
      ...prev,
      dateTo: e.target.value,
    }));
    setEndDate(e.target.value);
  };

  //handle publish date
  const handlePublishDate = (e) => {
    setFormData((prev) => ({
      ...prev,
      publishDate: e.target.value,
    }));
  };
  const handleReportTypeChange = (e) => {
    const selected = e.target.value;
    setSelectedReportType(selected);
    setFormData((prev) => ({ ...prev, reportType: selected }));
  };

  const handleReset = () => {
    // Reset all form state
    setSelectedReportType("");
    setStartDate("");
    setEndDate("");

    // Also reset the formData
    setFormData({
      reportType: "",
      dateFrom: "",
      dateTo: "",
      publishDate: "",
      synopticSituationSummaryText: "",
      synopticSituationHeadingText: "",
      synopticSituationBulletText: "",
      mapText: "",
    });
    setMapPhoto(null);

    setStatusMessage({ type: "", message: "" });

    // setFormData((prev) => ({
    //   ...prev,
    //   reportType: "",
    //   dateFrom: "",
    //   dateTo: "",
    //   publishDate: "",
    //   synopticSituationSummaryText: "",
    //   synopticSituationHeadingText: "",
    //   synopticSituationBulletText: "",
    // }));
  };

  const validateForm = () => {
    if (
      // !formData.commodity ||
      !formData.reportType ||
      !formData.dateFrom ||
      !formData.dateTo ||
      !formData.publishDate ||
      !formData.synopticSituationSummaryText ||
      !formData.synopticSituationHeadingText ||
      !formData.synopticSituationBulletText ||
      !formData.mapText ||
      !mapPhoto
    ) {
      setStatusMessage({
        type: "danger",
        message: "Please fill in all required fields.",
      });
      return false;
    }
    return true;
  };

  const handleSubmit = async () => {
    if (!validateForm()) return;
    setStatusMessage({ type: "info", message: "Please wait, file is being created..." });

    const submitData = new FormData();

    submitData.append("reportType", formData.reportType);
    submitData.append("dateFrom", formData.dateFrom);
    submitData.append("dateTo", formData.dateTo);
    submitData.append("publishDate", formData.publishDate);
    submitData.append(
      "synopticSituationSummaryText",
      formData.synopticSituationSummaryText
    );
    submitData.append(
      "synopticSituationHeadingText",
      formData.synopticSituationHeadingText
    );
    submitData.append(
      "synopticSituationBulletText",
      formData.synopticSituationBulletText
    );
    submitData.append("mapText", formData.mapText);
    if (mapPhoto) {
      submitData.append("mapPhoto", mapPhoto);
    }

    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/dynamicReports/input-report-data`,
        {
          method: "POST",
          body: submitData,
        }
      );

      const result = await response.json();

      if (response.ok) {
        // Generate and open PDF
        const pdfUrl = `${process.env.REACT_APP_API_URL}/generate-weekly-water-and-weather-report?startDate=${formData.dateFrom}&endDate=${formData.dateTo}&publishDate=${formData.publishDate}`;

        const pdfResponse = await fetch(pdfUrl);

        if (pdfResponse.status === 409) {
          setStatusMessage({
            type: "danger",
            message:
              "A report already exists for this publish date. Please choose a different date.",
          });
        }

        if (pdfResponse.ok) {
          setStatusMessage({
            type: "success",
            message: "Report submitted and PDF generated successfully!",
          });
          window.open(pdfUrl, "_blank");
        } else {
          setStatusMessage({
            type: "danger",
            message: "Failed to generate PDF.",
          });
        }
      } else {
        setStatusMessage({
          type: "danger",
          message: result.message || "Failed to submit data.",
        });
      }
    } catch (error) {
      setStatusMessage({
        type: "danger", 
        message: "An unexpected error occurred while submitting.",
      });
      console.error("Error:", error);
    }
  };

  return (
    <div className="container">
      <div className="row">
        <div className="col-2">
          <Sidebar />
        </div>
        <div className="col-10">
          <h2 className="my-5">Reports</h2>
          <div className="row">
            {/* Commodity Select */}
            {/* <div className="col">
              <label htmlFor="commoditySelect" className="form-label">
                Commodity
              </label>
              <select
                className="form-select"
                id="commoditySelect"
                value={selectedCommodity}
                onChange={handleCommodityChange}
              >
                <option value="">Select commodity</option>
                {commodities.map((opt) => (
                  <option key={opt.commodity} value={opt.commodity}>
                    {opt.commodity}
                  </option>
                ))}
              </select>
            </div> */}

            {/* Report Type Select */}
            <div className="col">
              <label htmlFor="reportSelect" className="form-label">
                Report Type
              </label>
              <select
                className="form-select"
                id="reportSelect"
                value={selectedReportType}
                onChange={handleReportTypeChange}
                // disabled={!reportTypes.length}
              >
                <option value="">Select a report type</option>
                {reportsName.map((report) => (
                  <option key={report.value} value={report.value}>
                    {report.name}
                  </option>
                ))}
              </select>
            </div>
            <div className="col">
              <div className="mb-3">
                <label for="formGroupExampleInput2" className="form-label">
                  From{" "}
                </label>
                <input
                  type="date"
                  className="form-control"
                  id="formGroupExampleInput2"
                  value={startDate}
                  onChange={(e) => {
                    const startDate = new Date(e.target.value);
                    const endDate = new Date(formData.dateTo);
                    // if (
                    //   formData.dateTo &&
                    //   (endDate - startDate) / (1000 * 60 * 60 * 24) > 7
                    // ) {
                    //   alert("Date range cannot be more than 5 days");
                    //   setFormData((prev) => ({
                    //     ...prev,
                    //     dateTo: "",
                    //   }));
                    //   setStartDate("");
                    //   setEndDate("");
                    //   return;
                    // }
                    handleStartDate(e);
                  }}
                />
              </div>
            </div>

            <div className="col">
              <div className="mb-3">
                <label for="formGroupExampleInput2" className="form-label">
                  To {""}
                </label>
                <input
                  type="date"
                  className="form-control"
                  id="formGroupExampleInput2"
                  value={endDate}
                  onChange={(e) => {
                    const startDate = new Date(formData.dateFrom);
                    const endDate = new Date(e.target.value);
                    // if (
                    //   formData.dateFrom &&
                    //   (endDate - startDate) / (1000 * 60 * 60 * 24) > 7
                    // ) {
                    //   alert("Date range cannot be more than 5 days");
                    //   setFormData((prev) => ({
                    //     ...prev,
                    //     dateFrom: "",
                    //   }));
                    //   setStartDate("");
                    //   setEndDate("");
                    //   return;
                    // }
                    handleEndDate(e);
                  }}
                />
              </div>
            </div>
          </div>
          <div className="col-4">
            <div className="mb-3">
              <label for="formGroupExampleInput2" className="form-label">
                Publish Date
              </label>
              <input
                type="date"
                className="form-control"
                id="formGroupExampleInput2"
                onChange={handlePublishDate}
              />
            </div>
          </div>

          <div className="col-md-6 mt-4">
            {/**Weather Outlook */}
            <h3>2. Weather Outlook</h3>

            {/**SVG ETC */}
            <label className="">2a. Synoptic Situation</label>

            <div className="">
              <textarea
                className="form-control"
                id="exampleFormControlTextarea1"
                rows="3"
                value={formData.synopticSituationSummaryText}
                onChange={handleSummaryChange}
              ></textarea>
            </div>

            {/**Nested field abcbcb */}
            <div>
              <label className=" mt-3">i. Heading</label>
              <input
                type="text"
                placeholder="i.e. Impacts for 3rd Decadal of March"
                className="form-control "
                value={formData.synopticSituationHeadingText}
                onChange={handleHeadingChange}
              />
            </div>
          </div>
          <div className="mt-4 ">
            <CKEditor
              editor={ClassicEditor}
              data="<p></p>"
              onReady={(editor) => {
                // You can store the "editor" and use when it is needed.
                // console.log("Editor is ready to use!", editor);
              }}
              onChange={(event, editor) => {
                const data = editor.getData();
                setFormData((prev) => ({
                  ...prev,
                  synopticSituationBulletText: data,
                }));
              }}
            />
          </div>
          <div>
            <label className=" mt-3">Map Text</label>
            <input
              type="text"
              placeholder="i.e. Monthly Temperature Outlook"
              className="form-control "
              value={formData.mapText}
              onChange={handleMapText}
            />
          </div>
          <div className="my-3 ">
            <label for="formFile" className="form-label">
              Upload Map Photo
            </label>
            <input
              className="form-control"
              type="file"
              id="formFile"
              accept="image/*"
              onChange={handleMapPhotoUpload}
            />
          </div>
          {statusMessage.message && (
            <div
              className={`alert alert-${statusMessage.type} mt-4`}
              role="alert"
            >
              {statusMessage.message}
            </div>
          )}
          <div className="d-flex justify-content-between">
            <div className="my-4">
              <button className="btn btn-success" onClick={handleSubmit}>
                Submit
              </button>
            </div>
            <div className="my-4">
              <button className="btn btn-danger" onClick={handleReset}>
                Reset All
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
